// javascript
import '../src/js/application';
// stylesheet
import '../src/scss/application.scss';

require.context('../src/images', true, /\.(png|jpg|jpeg|svg)$/);

import Rails from '@rails/ujs';
Rails.start();
